export class RestoreAzurePostgresDatabaseRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "AzurePostgresDatabaseRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzurePostgresDatabaseRequest.attributeTypeMap;
    }
    constructor() {
    }
}
